import {Component, Input, OnChanges} from '@angular/core';
import {AnimationOptions, LottieComponent} from 'ngx-lottie';
import {ShowcaseUseCase} from '../../../features/scenarios/config/demo-options';

@Component({
  selector: 'app-scenario-animation',
  imports: [LottieComponent],
  template: '<ng-lottie [options]="options" width="100%" height="100%" />',
  styles: ':host {display: block; height: 100%;} ng-lottie {display: block; height: 100%;}',
})
export class ScenarioAnimationComponent implements OnChanges {
  @Input({required: true}) useCase!: ShowcaseUseCase;

  options: AnimationOptions = {};

  ngOnChanges() {
    // No assetsPath: lottie-web resolves each asset's own "u" (e.g. "images/")
    // relative to the JSON's path, which already matches our folder layout.
    this.options = {
      path: `assets/animations/${this.useCase}/ic_animation_${this.useCase}.json`,
      loop: true,
      autoplay: true,
    };
  }
}
